import _ from 'lodash';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './SongPrompt.module.scss';
import roundRegistry from '../roundRegistry';
import classNames from 'classnames';
import posed from 'react-pose';
import {keysToSingleValue} from '../utils/objectFactory';
import {allPoses} from '../gameHelpers';
import * as audioBundle from '../audioBundle';

const visiblePromptPoses = ['prompt', 'right-answer'];

const Container = posed.div({
    ...keysToSingleValue(visiblePromptPoses, {
        y: 0,
        transition: {
            ease: 'easeOut',
            duration: 1000,
        },
    }),
    ...keysToSingleValue(_.difference(allPoses, visiblePromptPoses), {
        y: '50vh',
        transition: {
            ease: 'easeIn',
            duration: 1000,
        },
    }),
});

const Input = posed.input({
    wrong: {
        x: 0,
        transition: {
            x: {
                type: 'keyframes',
                values: ['0em', '0.25em', '-0.25em', '0em'],
                times: [0, 0.25, 0.75, 1],
                loop: 1,
                duration: 200,
            },
        },
    },
});

const RightSign = posed.div({
    'right-answer': {
        scale: 1,
        opacity: 1,
        transition: {
            ease: 'easeIn',
            duration: 500,
        },
    },
    ...keysToSingleValue(_.without(allPoses, 'right-answer'), {
        scale: 10,
        opacity: 0,
        transition: {duration: 0},
    }),
});

export default class SongPrompt extends Component {
    static propTypes = {
        game: PropTypes.object.isRequired,
        onChangeGame: PropTypes.func.isRequired,
        onRightAnswer: PropTypes.func.isRequired,
    };

    state = {
        answer: '',
        wrong: false,
        wrongKey: 0,
        inputActive: false,
    };

    componentDidUpdate(prevProps, prevState) {
        const inputElement = ReactDOM.findDOMNode(this.refs.input);

        if (prevProps.game.stage === this.props.game.stage) {
            return;
        }

        if (this.props.game.stage === 'prompt') {
            setTimeout(() => {
                this.setState({inputActive: true});
                inputElement.focus({preventScroll: true});
            }, 1000);
        } else {
            this.setState({inputActive: false});
            inputElement.blur();
        }
    }

    render() {
        const {answer, wrong, wrongKey, inputActive} = this.state;

        const inputClassName = classNames(styles.answer, {
            [styles.answerDisabled]: !inputActive,
        });

        return (
            <Container className={styles.prompt}>
                <div className={styles.question}>Who is the artist?</div>
                <div className={styles.inputLine}>
                    <RightSign className={styles.rightSign} />
                    <Input
                        ref='input'
                        pose={wrong ? 'wrong' : ''}
                        poseKey={wrongKey}
                        className={inputClassName}
                        value={answer}
                        tabIndex={inputActive ? 0 : -1}
                        onChange={this.setAnswer}
                        onKeyDown={this.handleKeyDown}
                    />
                </div>
                <div className={styles.line} />
                <div className={styles.hint}>hit enter to submit</div>
            </Container>
        );
    }

    setAnswer = ({target: {value}}) => {
        this.setState({answer: value});
    };

    handleKeyDown = event => {
        if (event.key === 'Enter') {
            this.submit();
        }
    };

    submit = () => {
        const {answer, wrongKey} = this.state;
        const {game} = this.props;
        const {similarAnswer} = roundRegistry[game.round];

        if (answer.trim().length === 0) {
            return;
        }

        const correct = similarAnswer.some(
            s => s.toLowerCase() === answer.trim().toLowerCase()
        );

        if (correct) {
            this.props.onRightAnswer();
            return;
        }

        audioBundle.play('wrong');

        const nextWrongKey = wrongKey + 1;
        this.setState({
            wrong: true,
            wrongKey: nextWrongKey,
        });
    };
}
